import { takeEvery, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { updateUser, errorUser, USER_POST } from 'actions/create-user'
import { getConfigJson, getMeta, updateUserData } from 'actions/general'
import { logInteraction } from 'util/log-interaction'

function _postUser({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('createUser')

      const token = action.payload.token

      const accountEndpoint = `/auth/activate/${token}`

      const values = action.payload.values
      const name = values.name.split(' ')

      values.firstName = name.shift()
      values.lastName = name.join(' ')
      values.password_confirm = values.password

      if (!values.githubCode) {
        values.githubCode = ''
      }

      const userRegistrationResult = yield call(create, accountEndpoint, values)
      const { orgslug } = userRegistrationResult

      yield put(
        updateUser({
          data: userRegistrationResult,
        })
      )
      yield put(
        updateUserData({
          orgslug,
          username: values.username,
          portalUrl: userRegistrationResult.returnTo,
        })
      )

      yield put(getConfigJson())
      yield put(getMeta({ orgslug }))

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData = data.msg

      if (errorData) {
        yield call(
          action.payload.reject,
          new SubmissionError({ _error: errorData })
        )
      } else {
        yield call(action.payload.reject)
      }

      yield put(
        errorUser({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postUser,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostUser(api, error) {
  yield takeEvery(USER_POST, _postUser(api, error))
}
